<template>
  <div v-if="isShowNoice" class="main_notice">
    {{ contentText }}
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

import { getGlobalNotice } from '@/api/login';
const isShowNoice = ref(0);
let timer: number | null = null;
const contentText = ref('');

onMounted(() => {
  fetchGetNoitce();
  timer = setInterval(() => {
    fetchGetNoitce();
  }, 1000 * 60 * 10);
});
const fetchGetNoitce = () => {
  getGlobalNotice().then((res) => {
    const { content, isShow } = res;

    isShowNoice.value = isShow;
    contentText.value = content;
  });
};
onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
});
</script>
<style lang="scss">
.main_notice {
  width: 100%;
  top: 0;
  left: 0;
  background-color: yellow;
  color: red;
  line-height: 1;
  padding: 10px 10px;
  padding-left: 24px;
  font-size: 14px;
  font-weight: 700;
}
</style>
